import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Iu person' el Kievo <br/>
        Longe dronadis en revo. <br/>
        Poste li revekiĝis, <br/>
        Kaj terure timiĝis, <br/>
        Ĉar okazis al revo la krevo.
      </p>

      <p class="poem-block mb-3">
        Iu knabin' el Odeso <br/>
        Falis en am' sen permeso. <br/>
        Ŝi suferis kaj ĝuis, <br/>
        Kun pasi' rendevuis, <br/>
        Sed finiĝis ja ĉio per ĉeso…
      </p>

      <p class="poem-block mb-3">
        Iu sprita rabisto el Bresto <br/>
        Prenis kason tutplene, sen resto. <br/>
        Estis en tiu kas’ <br/>
        De la mono amas’: <br/>
        Unu groŝo sur fundo de l’ kesto.
      </p>

      <p class="poem-block mb-3">
        Iu juna student’ el Rostovo <br/>
        Foje dormis en fremda alkovo. <br/>
        Kiam venis maten’ <br/>
        Li rimarkis kun splen’ <br/>
        Ke ĉe li restis  sola ĉurovo.
      </p>

      <p class="poem-block mb-3">
        Iu bela virin’ el Barato <br/>
        Kredis, ke ĉiu vir’ estas frato. <br/>
        Post nelonga turne’ <br/>
        Ŝi komprenis, ke ne, <br/>
        Sed ne estis por ŝi sortobato.
      </p>

      <p class="poem-block mb-3">
        Brita sir’ Isaak, saĝa homo, <br/>
        Ĉiam timis eliri el domo. <br/>
        Lin ne trafis fripon’ <br/>
        Tamen falis plafon’ <br/>
        Kaj ĝi pezis pli multe, ol pomo!
      </p>

      <p class="poem-block mb-3">
        Iu usona virino <br/>
        Volis lavi nur per lavmaŝino. <br/>
        Sed… ho, kiu konfuz’! <br/>
        Ne sukcesis amuz’: <br/>
        Estas «lavi» ne «love»! Punkto, fino.
      </p>

      <p class="poem-block mb-3">
        Iu turka paŝa’ en haremo <br/>
        Ekdeziris koiti ĝis tremo. <br/>
        Sed diskuris inar’, <br/>
        Kaj li restis sen par’. <br/>
        Venis emancipad’ al haremo!
      </p>

      <p class="poem-block mb-3">
        Iu virin’ el Komio <br/>
        Tre similis al mava simio. <br/>
        Kaj ne nur la vizaĝ’, <br/>
        Bedaŭrinde la saĝ’ <br/>
        Sama, kiel ĉe l’besta specio.
      </p>

      <p class="poem-block mb-3">
        Iu gaja drinkul’ el Torino <br/>
        Iam trinkis tro multe da vino. <br/>
        En haladz’ de l’ ebri’ <br/>
        Vidis li inojn tri <br/>
        En la lok’ de la propra edzino.

      <p class="poem-block mb-3">
        Iu kalva person’ el Kanbero <br/>
        Promenadis en granda sombrero. <br/>
        Ho, terura moment’! <br/>
        Forte blovis la vent’, <br/>
        Kaj ekflugis li al stratosfero.
      </p>

      <p class="poem-block mb-3">
        Iu frizist’ el Taŝkento <br/>
        Amindumis kun granda serpento. <br/>
        Pro brakuma sufok’ <br/>
        Li vekiĝis en ŝok’… <br/>
        Sed ne restis jam tempo por pento.
      </p>

      <p class="poem-block mb-3">
        Bela damo el land’ Rumanio <br/>
        Serĉesploris pri biokemio. <br/>
        Foje el la matras’ <br/>
        Tralikiĝis la gas’… <br/>
        Fil’ naskiĝis pro la reakcio.
      </p>

      <p class="poem-block mb-3">
        Iu povra soldat’ el kazerno <br/>
        Perdis monon sub strata lanterno. <br/>
        Jen briletas moner’! <br/>
        Li sin klinis al ter’… <br/>
        Lin akceptis profunda poterno.
      </p>

      <p class="poem-block mb-3">
        Iu juna poet’ el Lepanto <br/>
        Enamiĝis al lingv’ Esperanto. <br/>
        Venis li al Kongres’, <br/>
        Sed – ho ve, malsukces’! <br/>
        Kaj popol’, kaj simbol’ – por brokanto!
      </p>

      <p class="poem-block mb-3">
        Iu usonanin’ el Ĉinio <br/>
        Tre suferis pro rena hernio. <br/>
        Dum futbal’-mondial’ <br/>
        Post triop-seks-batal’ <br/>
        De l’ malsano jam restis nenio!
      </p>

    </div>
    `
  )
}


const itemName = {
  esp: 'Limerikoj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;